import React, { useEffect, useState } from 'react';
import { Container, Alert, Button, Spinner } from 'react-bootstrap';
import { Link, Navigate } from 'react-router-dom';
import featureFlagService, { FEATURES } from '../services/featureFlagService';

/**
 * Payment cancellation page displayed if the user cancels the Stripe checkout
 */
const PaymentCancelPage = () => {
  const [loading, setLoading] = useState(true);
  const [paymentsEnabled, setPaymentsEnabled] = useState(false);

  useEffect(() => {
    const checkFeatureFlag = async () => {
      try {
        const isEnabled = featureFlagService.isFeatureEnabled(FEATURES.STRIPE_PAYMENTS);
        setPaymentsEnabled(isEnabled);
      } finally {
        setLoading(false);
      }
    };
    
    checkFeatureFlag();
  }, []);

  if (loading) {
    return (
      <Container className="my-5 text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  // If payments are disabled, redirect to home page
  if (!paymentsEnabled) {
    return <Navigate to="/" />;
  }
  return (
    <Container className="my-5 text-center">
      <Alert variant="warning" className="mb-4">
        <Alert.Heading>Payment Cancelled</Alert.Heading>
        <p>
          Your payment process was cancelled and no charges were made to your account.
        </p>
      </Alert>
      
      <p className="mb-4">
        If you encountered any issues during checkout or have questions about our premium features, 
        please don't hesitate to contact our support team.
      </p>
      
      <div className="d-flex justify-content-center gap-3">
        <Button as={Link} to="/premium-upgrade" variant="primary">
          Try Again
        </Button>
        <Button as={Link} to="/" variant="outline-secondary">
          Return Home
        </Button>
      </div>
    </Container>
  );
};

export default PaymentCancelPage;
